import { useState } from 'react';
import { previewInvoice } from '../services/invoice.services';
import { useDataAuth } from './useDataAuth';


export function useElectronicDocument() {
    const [{ userSession }] = useDataAuth();
    const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
    const [pdfBase64, setPdfBase64] = useState('');


    const handleClosePreviewDialog = () => {
        setOpenPreviewDialog(false);
        setPdfBase64('');
    };

    const getPreviewDocument = async (id, action) => {
        try {
            const previewResponse = await previewInvoice(userSession.token, id, action);
            if (previewResponse.status === 200) {
                setPdfBase64(`data:application/pdf;base64,${previewResponse.data}`);
                setOpenPreviewDialog(true);
            }
        } catch (error) {
            console.error("Error fetching preview document:", error);
        }
    };

    return {
        openPreviewDialog,
        pdfBase64,
        handleClosePreviewDialog,
        getPreviewDocument
    }
}
